import {
  Box,
  Button,
  SimpleGrid,
  Flex,
  HStack,
  Image,
  Select,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";

const newsData = [
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/News.png" },
];

const News = () => {
  const [category, setCategory] = useState("All");

  return (
    <Box flex="1" pt="40px" px="8">
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="30px" color="#101828">
        Latest news
        </Text>
        <Button
          background="#1e98d7"
          color="#ffffff"
          _hover="none"
          fontSize="14px"
        >
          Create New Article
        </Button>
      </Flex>

      <Flex gap={4} wrap="wrap" mb={12}>
        <Select
          placeholder="Date (Newest first)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
      </Flex>

      {/* News Grid */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={5} mt={2}>
        {newsData.map((news, index) => (
          <Box key={index} borderRadius="md" overflow="hidden">
            <Image
              src={news.image}
              alt="News"
              w="100%"
              h="auto"
              objectFit="contain"
            />
            <Box pt={5} pb={5}>
              {/* Title & Date in same line with dot separator */}
              <HStack justify="space-between">
                <Text fontSize="12" color="#344054">
                  {news.title} • {news.date}
                </Text>
              </HStack>

              {/* Main Heading Bold */}
              <Text mt={2} fontSize="16px" color="#101828">
                The balance between print and digital communications
              </Text>

              {/* Subtext Slightly Smaller */}
              <Text mt={2} fontSize="14px" color="#475467">
                Recent research suggests organisations are settling on a blend
                of the two
              </Text>

              {/* Finance Tag - Styled as per your requirement */}
              <Box
                id="finance"
                mt={3}
                w="73px"
                h="24px"
                bg="white"
                border="1px solid #d5d9eb"
                borderRadius="full"
                textAlign="center"
                fontSize="12px"
                color="#363f72"
                display="flex"
                alignItems="center"
                justifyContent="center"
                backgroundColor="#f8f9fc"
                mb={12}
              >
                Finance
              </Box>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default News;
